var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDropDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 24,
    viewBox: "0 0 12 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.70175 13.2982L3.70175 10.2982C3.52632 10.1053 3.2807 10 3 10C2.45614 10 2 10.4561 2 11C2 11.2807 2.10526 11.5263 2.29825 11.7018L5.29825 14.7018C5.47368 14.8947 5.7193 15 6 15C6.54386 15 7 14.5439 7 14C7 13.7193 6.89474 13.4737 6.70175 13.2982ZM8.29825 10.2982L5.29825 13.2982C5.10526 13.4737 5 13.7193 5 14C5 14.5439 5.45614 15 6 15C6.2807 15 6.52632 14.8947 6.70175 14.7018L9.70175 11.7018C9.89474 11.5263 10 11.2807 10 11C10 10.4561 9.54386 10 9 10C8.7193 10 8.47368 10.1053 8.29825 10.2982ZM3 12H9C9.54386 12 10 11.5439 10 11C10 10.4561 9.54386 10 9 10H3C2.45614 10 2 10.4561 2 11C2 11.5439 2.45614 12 3 12ZM3 11L6 14L9 11H3Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDropDown);
export default __webpack_public_path__ + "static/media/arrow_drop_down.30d21211.svg";
export { ForwardRef as ReactComponent };